import SiteLanguages from "./components/SiteLanguages";
import "./main.css";
import Certifications from "./sections/certifications";
import Education from "./sections/education";
import ProfessionalExperience from "./sections/experience";
import Languages from "./sections/languages";
import ProfessionalSummary from "./sections/professionalSummary";
import Skills from "./sections/skills";

export default function Main() {
  return (
    <main className="main">
      <div className="main-content">
        <SiteLanguages />

        <ProfessionalSummary />
        <Skills />
        <ProfessionalExperience />
        <Education />
        <Certifications />
        <Languages />
      </div>
    </main>
  );
}
